import FormAction from './form_action';

export default class SearcherFormAction extends FormAction {
	_searchOnLoad;
	_searcherType;
	_mappings;
	_dataStoreRoute;

	constructor(actionProps = {}) {
		super(actionProps);
	}

	get searchOnLoad() {
		return this._searchOnLoad;
	}

	set searchOnLoad(value) {
		this._searchOnLoad = value;
	}

	get searcherType() {
		return this._searcherType;
	}

	set searcherType(value) {
		this._searcherType = value;
	}

	get mappings() {
		return this._mappings;
	}

	set mappings(value) {
		this._mappings = value;
	}

	get dataStoreRoute() {
		return this._dataStoreRoute;
	}

	set dataStoreRoute(value) {
		this._dataStoreRoute = value;
	}
}
